import { render, staticRenderFns } from "./LmDataTableView.vue?vue&type=template&id=20c63fbc"
import script from "./LmDataTableView.vue?vue&type=script&lang=js"
export * from "./LmDataTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports